import IntakeReviewAgentIcon from "../../../assets/logos/IntakeReviewAgent.svg";
import BenefitAgentIcon from "../../../assets/logos/BenefitAgent.svg";
import DocAgentIcon from "../../../assets/logos/DocumentQualityAgent.svg";
import DefaultUser from "../../../assets/logos/Profile.svg";
import ApplicationAssistant from '../../../assets/logos/ApplicationStatusAgent.svg';
import EligibilityAgentIcon from '../../../assets/logos/EligibilityReviewAgent.svg'

export const AGENT_UI = {
  "Intake Review Agent": {
    label: "Intake Review Agent",
    icon: IntakeReviewAgentIcon,
  },
  "Eligibility Review Agent": {
    label: "Eligibility Review Agent",
    icon: EligibilityAgentIcon,
  },

  "Duplicate Report": {
    label: "Duplicate Report",
    icon: IntakeReviewAgentIcon,
  },

  "Benefits Agent": {
    label: "Benefits Agent",
    icon: BenefitAgentIcon,
  },

  "Benefits Report": {
    label: "Benefits Agent",
    icon: BenefitAgentIcon,
  },

  "Document Quality Agent": {
    label: "Document Quality Agent",
    icon: DocAgentIcon,
  },

  "Application Status Agent": {
    label: "Application Status Agent",
    icon: ApplicationAssistant,
  },

};

export const getAgentUI = (agentId) => AGENT_UI[agentId] || {
  label: "Agent",
  icon: DefaultUser,
};
